import {makeStyles} from '@material-ui/core/styles';
import {getDirectionStyles} from '../../../../../utils/ThemeUtils';

export const useStyles = makeStyles(({palette, direction}) => ({
    monthButton: {
        width: '80px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        fontSize: '14px',
        fontWeight: 300,
        textTransform: 'uppercase',
        zIndex: 1
    },
    monthButtonSelected: {
        backgroundColor: palette.primary.main,
        '&:hover': {
            backgroundColor: palette.primary.main
        }
    },
    monthButtonPreselected: {
        // @ts-ignore
        backgroundColor: palette.calendar.preselectedFirst.main as string,
        '&:hover': {
            // @ts-ignore
            backgroundColor: palette.calendar.preselectedFirst.main as string
        }
    },
    range: {
        color: palette.calendar.selected.main,
        '&:after': {
            position: 'absolute',
            width: '50%',
            height: '100%',
            zIndex: 0,
            backgroundColor: palette.calendar.selected.main
        }
    },
    rangeEndPreselected: {
        color: palette.calendar.selected.main,
        '&:after': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)'
        }
    },
    rangeStart: {
        '&:after': {
            content: '""',
            [getDirectionStyles<string>(direction)('right', 'left')]: 0
        }
    },
    rangeEnd: {
        '&:after': {
            content: '""',
            [getDirectionStyles<string>(direction)('left', 'right')]: 0
        }
    },
    rangeSelected: {
        backgroundColor: palette.calendar.selected.main,
        color: palette.text.primary
    },
    rangePreselected: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',

        // @ts-ignore
        color: palette.dividerStrong
    },
    cell: {
        position: 'relative',
        flex: '1 0 25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
